class PickupPointOfServiceFormController {
    /*@ngInject*/
    constructor() {
        this.requestPending = false;
        this.pickupPointOfServiceForm = document.getElementById('pickupPointOfServiceForm');
        this.paidPickupPointOfServiceForm = document.getElementById('paidPickupPointOfServiceForm');
    }

    submit(form) {
        this.requestPending = true;
        form.$$element.submit();
    }

    submitPlaceReservation() {
        this.pickupPointOfServiceForm.submit();

    }
    submitPaidPickup() {
        this.paidPickupPointOfServiceForm.submit();
    }
}

export default PickupPointOfServiceFormController;